export enum ContentByteType {
  SKILL = "skill",
  STORY = "story",
  CHATBOT = "chatbot",
  INTERACTVE_STORY="interactive_story"
}

